/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {CheckboxUnchecked, CheckboxChecked, CheckboxWithError, CheckboxSuffix, CheckboxDifferentSizes, CheckboxDisabled, CheckboxWithErrorStates, CheckboxBoundingArea, CheckboxIndeterminate, CheckboxIndeterminateLarge} from 'Docs/uilib/components/checkbox/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    h3: "h3",
    p: "p",
    code: "code",
    a: "a"
  }, _provideComponents(), props.components), {VisibleWhenVisualTest} = _components;
  if (!VisibleWhenVisualTest) _missingMdxReference("VisibleWhenVisualTest", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Demos"
    }), "\n", _jsx(_components.h3, {
      children: "Unchecked Checkbox (default state)"
    }), "\n", _jsx(CheckboxUnchecked, {}), "\n", _jsx(_components.h3, {
      children: "Checked Checkbox, left label position"
    }), "\n", _jsx(CheckboxChecked, {}), "\n", _jsx(_components.h3, {
      children: "Checked Checkbox with error message"
    }), "\n", _jsx(CheckboxWithError, {}), "\n", _jsx(_components.h3, {
      children: "Checkbox with suffix"
    }), "\n", _jsx(CheckboxSuffix, {}), "\n", _jsx(_components.h3, {
      children: "With different sizes"
    }), "\n", _jsxs(_components.p, {
      children: ["As for now, there are two sizes. ", _jsx(_components.code, {
        children: "medium"
      }), " is the default size."]
    }), "\n", _jsx(CheckboxDifferentSizes, {}), "\n", _jsx(_components.h3, {
      children: "Disabled checkbox"
    }), "\n", _jsx(CheckboxDisabled, {}), "\n", _jsx(_components.h3, {
      children: "Indeterminate state (partially checked)"
    }), "\n", _jsx(_components.p, {
      children: "The checkbox offers a fully controlled indeterminate state."
    }), "\n", _jsxs(_components.p, {
      children: ["Here is a indeterminate state ", _jsx(_components.a, {
        href: "/uilib/extensions/forms/base-fields/Indeterminate",
        children: "working example"
      }), "."]
    }), "\n", _jsx(CheckboxIndeterminate, {}), "\n", _jsx(CheckboxIndeterminateLarge, {}), "\n", _jsxs(VisibleWhenVisualTest, {
      children: [_jsx(CheckboxWithErrorStates, {}), _jsx(CheckboxBoundingArea, {})]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
